import { UserContext_Agent } from '@/context/user/user.types'

export interface LoginBody_Response {
  token: string
  user: {
    agent: UserContext_Agent
    email: string
    full_name: string
    home_block_permitted: boolean
    id: number
    is_agm: boolean
    is_billing: boolean
    is_hub_manager: boolean
    is_super_admin: boolean
    is_xteam: boolean
    market_segment_ids: number[]
    role: number
  }
}

export namespace LoginAPI {
  export namespace REFRESH {
    export type Body = {}
    export type Response = LoginBody_Response
  }

  export function refresh() {
    return { url: '/rusty/refresh_token', method: 'post' }
  }
}
